<template>
  <div class="prism row my-5" id="congrats">
    <div class="col my-5">
      <template v-if="!showSurvey">
        <div class="text-center">
          <img width="120" :src="thankYouImageUrl" class="mx-auto" alt="Thank you for purchasing" />
          <Heading class="max-w-3xl m-auto" level="h2" size="h2" align-center>
            {{ I18n.t("checkout.thank_you") }}
          </Heading>
          <p class="text-typo-secondary text-lg mt-4" v-html="purchaseFeedback"></p>
          <Button as="link" href="/upload" class="mt-12"> {{ I18n.t("checkout.remove_backgrounds") }}</Button>
        </div>
      </template>
      <template v-else>
        <template v-if="thankUserForSurvey">
          <div class="text-center">
            <Heading size="h1" level="h1"> {{ I18n.t("checkout.survey.thank_you") }} </Heading>
            <p class="text-typo-secondary text-lg mt-12">{{ I18n.t("checkout.survey.post_submit_subheader") }}</p>
          </div>
        </template>
        <template v-else>
          <div class="text-center">
            <Heading class="max-w-3xl m-auto" level="h2" size="h2" align-center>
              {{ I18n.t("checkout.thank_you") }}
            </Heading>
            <p class="text-2xl max-w-3xl mx-auto text-typo-secondary font-normal mt-12 mb-0">
              {{ I18n.t("checkout.survey.use_case.sub_heading") }}
            </p>
          </div>
        </template>
        <PostPurchaseSurvey
          v-if="showSurvey"
          class="mb-4 mt-12"
          :use-case-options="useCaseOptions"
          @submittedSurvey="onSubmittedSurvey"
        />
        <template v-if="thankUserForSurvey">
          <div class="dropzone-enabled"></div>
          <div class="relative group flex flex-col gap-4 md:gap-8 max-w-md mb-4 mx-auto">
            <UploadWidget />
          </div>
        </template>
      </template>
      <div class="mt-12">
        <FAQSection :faq-heading="faqHeading" :faqs="faqs" :display-help-center="false" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { inject, ref } from "vue";
import { FAQ } from "../plans/types";
import PostPurchaseSurvey from "./post_purchase_survey.vue";
import { Heading, Button } from "prism";
import UploadWidget from "../prism/upload_widget.vue";
import FAQSection from "../plans/faq_section.vue";

const I18n = inject("I18n");

defineProps<{
  showSurvey: Boolean;
  faqs: FAQ[];
  faqHeading: string;
  useCaseOptions: string[];
  purchaseFeedback: string;
  thankYouImageUrl: string;
}>();

const thankUserForSurvey = ref(false);

const onSubmittedSurvey = () => {
  thankUserForSurvey.value = true;
  // scroll to top to show thank you message
  document.body.scrollTop = document.documentElement.scrollTop = 0;
};
</script>
